module.exports = __webpack_public_path__ + "img/icon_53.d3b993ac.png";